import React, { Component } from 'react';

class GenericTooltip  extends Component{
    renderTooltip(){
        const {  payload, colors } = this.props; 
        return (
            <div className="custom-tooltip">
                <p className="custom-tooltip-title" style={{color:colors[0]}}>
                    {payload[0].payload.name}
                </p>
                <p style={{color:colors[2], fontSize:'15px'}}>
                    {payload[0].value}
                </p>         
            </div>
        )
    }
  
    render() {
        const { active } = this.props;
        if (active) {
            return (
                this.renderTooltip()
            )
        }  
        return null;
    }
}

export default GenericTooltip;